export enum EScreenSize {
    DESKTOP = 'DESKTOP',
    LAPTOP = 'LAPTOP',
    MOBILE = 'MOBILE',
}